<template>
  <div class="search-results-page">
    <h3>{{ formattedTitle }}</h3>

    <div class="w-100 d-flex justify-content-between">
      <!-- 페이지 당 표시할 항목 수 선택 -->
      <b-form-group label-cols="12" label-for="per-page-select" variant="info">
        <b-form-select
          id="per-page-select"
          v-model="perPage"
          :options="[5, 10, 15, 20]"
          class="mb-3"
        ></b-form-select>
      </b-form-group>
      <div class="d-flex align-items-center flex-wrap">
        <!-- 검색 입력 -->
        <b-form-group label-cols="12" label-for="search-input">
          <b-form-input
            id="search-input"
            placeholder="검색어를 입력하세요..."
            v-model="searchTerm"
            align="right"
          ></b-form-input>
        </b-form-group>
      </div>
    </div>

    <div v-if="!filteredResults || loading" class="d-flex justify-content-center">
      <b-spinner label="Spinning" variant="secondary"></b-spinner>
    </div>
    <p v-else-if="!!filteredResults && filteredResults.length === 0">검색 결과가 없습니다.</p>

    <ul v-else>
      <div
        v-for="(result, index) in paginatedResults" 
        :key="index" 
        class="cursor"
      >
        <li @click="movePage(result)">
          <h6 class="fw-600">
            {{ index + 1}}. <b-icon icon="house-door" class="ml-3"/> / {{ result.lv1_info.name }} / {{ result.lv2_info.name }}
          </h6>
          <hr class="m-0">
          <p>{{ truncateText(decodeHtmlEntities(stripHtmlTags(result.text)), 200) }}</p>
        </li>
      </div>
    </ul>

    <!-- 페이지네이션 컴포넌트 -->
    <b-pagination
      v-if="filteredResults"
      v-model="currentPage"
      :per-page="perPage"
      :total-rows="filteredResults.length"
      align="fill"
      aria-controls="table-pagination"
      class="pb-3"
    ></b-pagination>
  </div>
</template>

<script>
  import { mapMutations, mapState } from 'vuex';
  import { updateParamsFromQueryString } from '../util';

  export default {
  name: "SearchResults",
  data() {
    return {
      perPage: 10, 
      currentPage: 1, 
      searchTerm: "",
    };
  },
  methods: {
    ...mapMutations('story_board', ['update_selected_lv1', 'update_selected_lv2']),
    movePage(selected_disclosure) {
      history.pushState(null, null, '#order_id_' + selected_disclosure.order_index);

      window.scrollTo(0, 0);
      this.update_selected_lv1({lv1_info: selected_disclosure.lv1_info, view_mode: this.view_mode});
      this.update_selected_lv2({lv2_info: selected_disclosure.lv2_info, view_mode: this.view_mode});
      
      updateParamsFromQueryString('lv1', selected_disclosure.lv1_info.name, false);
      updateParamsFromQueryString('lv2', selected_disclosure.lv2_info.name, false);
      updateParamsFromQueryString('q_str', this.searchKeyword, false, false);
      updateParamsFromQueryString('order_id_', selected_disclosure.order_index, false, false);
      const currentUrl = new URL(window.location.href);
      const path = currentUrl.pathname; 
      const query = Object.fromEntries(currentUrl.searchParams.entries()); 

      this.$router.replace({ path, query });
      this.$emit("closeSearch");
    },
    stripHtmlTags(html) {
      return html.replace(/<[^>]*>?/gm, '');
    },

    truncateText(text, maxLength) {
      if (text.length > maxLength) {
        return text.slice(0, maxLength) + '...';
      }
      return text;
    },

    decodeHtmlEntities(text) {
      if (typeof text !== 'string') return text;
      const textarea = document.createElement('textarea');
      textarea.innerHTML = text;
      return textarea.value;
    },
  },
  props: {
    searchResults: { type: Array, default: () => null },
    loading: { type: Boolean, default: true },
    searchKeyword: { type: String, default: "" },
  },
  computed: {
    ...mapState('report_list', ['view_mode']),
    formattedTitle() {
      const keyword = this.$route.query.search_keyword || this.searchKeyword || "";
      return keyword ? `'${keyword}' 검색 결과` : "검색 결과";
    },

    filteredResults() {
      if (this.searchResults === null) {
        return null
      }
      if (!this.searchTerm) {
        return this.searchResults;
      }
      return this.searchResults.filter((item) => {
        return (
          item.lv1_info.name.includes(this.searchTerm) ||
          item.lv2_info.name.includes(this.searchTerm) ||
          item.text.includes(this.searchTerm)
        );
      });
    },

    paginatedResults() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.filteredResults.slice(start, end);
    },
  },
  watch: {
    perPage(newVal, oldVal) {
      this.currentPage = 1;
    },
    searchTerm(newVal, oldVal) {
      this.currentPage = 1;
    },
  },
};
</script>

<style scoped>
.search-results-page {
  padding: 0px;
  max-height: 500px;
}

.search-results-page h2 {
  margin-bottom: 20px;
}

.search-results-page ul {
  list-style-type: none;
  padding: 0;
}

.search-results-page li {
  margin-bottom: 15px;
  padding: 10px;
  background-color: transparent;
  border: 1px solid var(--gray-300);
  border-radius: 4px;
}

.search-results-page li:hover {
  background-color: var(--gray-100);
}
</style>
